import React from 'react';
import AttachmentsCampaign from '@/containers/CampaignDetail/Attachments/Attachments';

const Attachments: React.FC = () => {
  return <AttachmentsCampaign subCR />;
};

export default Attachments;
